<template>
    <div>
        <el-form ref="forms" label-width="100px" class="forms-lines">
            <el-form-item label="规格分类">
                <el-select v-model="fl_value" clearable placeholder="请选择" size="small" @change="getflxx">
                    <el-option v-for="item in fl_options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <div v-for="(item,index) in ggxxitem" :key="index">
                <div class="u-f">
                    <div class="mc">{{item.data.name}}</div>
                    <el-checkbox-group v-model="ggvalue" size="small">
                        <el-checkbox-button v-for="itemed in item.item" :key="itemed.id" :label="itemed.id">
                            {{itemed.value}}</el-checkbox-button>
                    </el-checkbox-group>
                </div>
            </div>
            <el-form-item label="设置规格">
                <el-button type="primary" @click="setgzxx" size="small">确定</el-button>
            </el-form-item>

            <el-form-item label="设置规格">
                <el-button type="primary" @click="setspsx" size="small">设置商品属性</el-button>
                <el-button @click="clearspsx" size="small">清空商品属性</el-button>
            </el-form-item>

            <el-form-item>
                <el-table :data="tableData" style="width: 100%" border>
                     <el-table-column v-for="(item,index) in head" :key='index' :label="item.name" >
                            <template slot-scope="scope">
                               {{scope.row[item.key]}}
                            </template>
                     </el-table-column>
                </el-table>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                fl_options: [],
                fl_value: '',
                ggxxitem: [],
                ggvalue: [],
                tableData: [],
                head:[]
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {

        },
        methods: {
            getflxx() {
                axios
                    .post("/admin/ShopGoods/getAttr", {
                        id: this.fl_value,
                        goods_id: 0
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.ggxxitem = response.data.data.result
                    })
                    .catch(error => {})
            },
            setgzxx() {
                axios
                    .post("/admin/ShopGoods/getAttrData", {
                        id: this.ggvalue.toString(),
                        goods_id: 0,
                        t: 1,
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.head = response.data.data.head
                        var arr=[{key:'ssjg',name:'销售价格'},{key:'scjg',name:'市场价格'},{key:'cbjg',name:'成本价格'},
                        {key:'zl',name:'重量（克）'}, {key:'kc',name:'库存'}]
                        this.head=this.head.concat(arr)
                        this.tableData = response.data.data.value
                        this.tableData.forEach(element => {
                            element.ssjg=''
                            element.scjg=''
                            element.cbjg=''
                            element.zl=''
                            element.kc=''
                        }); 
                    })
                    .catch(error => {})

            },
            setspsx(){

            },
            clearspsx(){

            },
        }
    }
</script>

<style scoped>
    .mc {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
    }
</style>